    (function() {
        const addons = ["product-tabs", "product-bullet-points", "sticky-addtocart", "trust-badge", "instagram-feed", "add-to-cart-animation", "announcement-bar", "cart-bubble", "instagram-feed", "product-bullet-points", "product-tabs", "product-tabs", "sticky-addtocart", "trust-badge", "cart-goal"];
        document.dispatchEvent(new CustomEvent('theme:addons:loaded', {
            detail: {
                addons
            }
        }));
    })();